module.exports = __webpack_public_path__ + "static/media/collapseArrowIcon.fe8ab1df.svg";